(() => {
  const FONT_MAP = {
    Classic: "GM-Classic", Royal: "GM-Royal", Silk: "GM-Silk",
    Romance: "GM-Romance", Vibe: "GM-Vibe", Arabic: "GM-Arabic",
    Hebrew: "GM-Hebrew", Korean: "GM-Korean", Cyrillic: "GM-Cyrillic",
    Hiragana: "GM-Japanese-Hiragana", Katakana: "GM-Japanese-Katakana",
    Kanji: "GM-Japanese-Kanji",
  };

  const COLOR_MAP = {
  "18K Gold": "#C9A227",
  "Rhodium Silver": "#8F9194",
  "18K Rose Gold": "#B97868"
  };

  // Shopify variant option "Silver · Rhodium" was renamed to "Rhodium Silver".
  // Accept both (plus a bare "Silver") so the preview keeps colouring correctly
  // no matter which label a given product still carries.
  const FINISH_ALIASES = {
    "silver · rhodium": "Rhodium Silver",
    "silver rhodium": "Rhodium Silver",
    "rhodium silver": "Rhodium Silver",
    "rhodium": "Rhodium Silver",
    "silver": "Rhodium Silver",
    "18k gold": "18K Gold",
    "gold": "18K Gold",
    "18k rose gold": "18K Rose Gold",
    "rose gold": "18K Rose Gold"
  };
  function normalizeFinish(value) {
    const raw = (value || "").trim();
    if (!raw) return "18K Gold";
    return FINISH_ALIASES[raw.toLowerCase()] || raw;
  }

  const FONT_SCALE = {
    "GM-Classic": 1.5, "GM-Royal": 1.6, "GM-Silk": 1.0, "GM-Romance": 1.2,
    "GM-Vibe": 1.6, "GM-Arabic": 1.2, "GM-Hebrew": 1.2, "GM-Korean": 1.2,
    "GM-Cyrillic": 1.2, "GM-Japanese-Hiragana": 1.2, "GM-Japanese-Katakana": 1.2,
    "GM-Japanese-Kanji": 1.2,
  };

  const FONT_Y_OFFSET = {
    "GM-Classic": 22,
    "GM-Royal": 26,
    "GM-Silk": -6,
    "GM-Romance": 10,
    "GM-Vibe": 24
  };
  // GM-Silk's capital letters and descenders (Y, j, g, y) reach
  // further than the other Latin fonts at the same size. This
  // flags the preview element so CSS can give it extra room,
  // without touching the box for every other font.
  function applySilkClipFix(textEl, fontFamily) {
    textEl.classList.toggle("gm-font-silk", fontFamily === "GM-Silk");
  }
  const TYPING_INTERVAL = 350;
  const debounceTimers = new WeakMap();
  const wrapperIds = new WeakMap();
  const previewPaintVersions = new WeakMap();
  const previewLastRender = new WeakMap();
  const engineSuggestions = new WeakMap();
  let uniqueCounter = 0;
  
  let dynamicGlossary = {
    kana: {}, kanji: {}, korean: {}, arabic: {}, hebrew: {}, cyrillic: {}
  };
  let glossaryLoaded = false;
  let glossaryPromise = null;

  // YOUR EXACT STATUS MESSAGES
  const STATUS_MESSAGES = {
    glossary: {
      text: "This is our suggested spelling, you can edit it here if you'd like.",
      variant: "neutral",
    },
    phonetic: {
      text: "This is our suggested spelling, you can edit it here if you'd like.",
      variant: "neutral",
    },
    review: {
      text: "This is our suggested spelling, you can edit it here if you'd like.",
      variant: "neutral",
    },
    kanji_fallback: {
      text: "Foreign names are usually written in Katakana. If you have a specific Kanji in mind, you can enter it here.",
      variant: "neutral",
    },
    neutral: {
      text: "This is our suggested spelling, you can edit it here if you'd like.",
      variant: "neutral",
    },
  };

  const BASIC_CYRILLIC_FALLBACK = {
    ru: { a: "а", b: "б", c: "к", d: "д", e: "е", f: "ф", g: "г", h: "х", i: "и", j: "дж", k: "к", l: "л", m: "м", n: "н", o: "о", p: "п", q: "к", r: "р", s: "с", t: "т", u: "у", v: "в", w: "в", x: "кс", y: "й", z: "з" },
    uk: { a: "а", b: "б", c: "к", d: "д", e: "е", f: "ф", g: "г", h: "х", i: "і", j: "дж", k: "к", l: "л", m: "м", n: "н", o: "о", p: "п", q: "к", r: "р", s: "с", t: "т", u: "у", v: "в", w: "в", x: "кс", y: "й", z: "з" },
    sr: { a: "а", b: "б", c: "ц", d: "д", e: "е", f: "ф", g: "г", h: "х", i: "и", j: "ј", k: "к", l: "л", m: "м", n: "н", o: "о", p: "п", q: "к", r: "р", s: "с", t: "т", u: "у", v: "в", w: "в", x: "кс", y: "и", z: "з" },
    bg: { a: "а", b: "б", c: "к", d: "д", e: "е", f: "ф", g: "г", h: "х", i: "и", j: "дж", k: "к", l: "л", m: "м", n: "н", o: "о", p: "п", q: "к", r: "р", s: "с", t: "т", u: "у", v: "в", w: "в", x: "кс", y: "й", z: "з" }
  };

  const BASIC_KOREAN_MULTI_MAP = [
    ["kk", "ㄲ"], ["tt", "ㄸ"], ["pp", "ㅃ"], ["ss", "ㅆ"], ["jj", "ㅉ"], ["ng", "ㅇ"], ["ch", "ㅊ"], ["sh", "ㅅ"], ["kh", "ㅋ"], ["ph", "ㅍ"], ["th", "ㅌ"],
    ["yae", "ㅒ"], ["ya", "ㅑ"], ["yeo", "ㅕ"], ["ye", "ㅖ"], ["wae", "ㅙ"], ["wa", "ㅘ"], ["oe", "ㅚ"], ["wo", "ㅝ"], ["we", "ㅞ"], ["wi", "ㅟ"], ["yu", "ㅠ"], ["yo", "ㅛ"],
    ["eu", "ㅡ"], ["ui", "ㅢ"], ["ae", "ㅐ"], ["eo", "ㅓ"], ["oo", "ㅜ"], ["ou", "ㅜ"]
  ];
  const BASIC_KOREAN_SINGLE_MAP = { a: "ㅏ", b: "ㅂ", c: "ㅋ", d: "ㄷ", e: "ㅔ", f: "ㅍ", g: "ㄱ", h: "ㅎ", i: "ㅣ", j: "ㅈ", k: "ㅋ", l: "ㄹ", m: "ㅁ", n: "ㄴ", o: "ㅗ", p: "ㅍ", q: "ㅋ", r: "ㄹ", s: "ㅅ", t: "ㅌ", u: "ㅜ", v: "ㅂ", w: "ㅜ", x: "ㅋㅅ", y: "ㅣ", z: "ㅈ" };
  const HANGUL_INITIALS = { "ㄱ": 0, "ㄲ": 1, "ㄴ": 2, "ㄷ": 3, "ㄸ": 4, "ㄹ": 5, "ㅁ": 6, "ㅂ": 7, "ㅃ": 8, "ㅅ": 9, "ㅆ": 10, "ㅇ": 11, "ㅈ": 12, "ㅉ": 13, "ㅊ": 14, "ㅋ": 15, "ㅌ": 16, "ㅍ": 17, "ㅎ": 18 };
  const HANGUL_MEDIALS = { "ㅏ": 0, "ㅐ": 1, "ㅑ": 2, "ㅒ": 3, "ㅓ": 4, "ㅔ": 5, "ㅕ": 6, "ㅖ": 7, "ㅗ": 8, "ㅘ": 9, "ㅙ": 10, "ㅚ": 11, "ㅛ": 12, "ㅜ": 13, "ㅝ": 14, "ㅞ": 15, "ㅟ": 16, "ㅠ": 17, "ㅡ": 18, "ㅢ": 19, "ㅣ": 20 };
  const HANGUL_FINALS = { "": 0, "ㄱ": 1, "ㄲ": 2, "ㄴ": 4, "ㄷ": 7, "ㄹ": 8, "ㅁ": 16, "ㅂ": 17, "ㅅ": 19, "ㅆ": 20, "ㅇ": 21, "ㅈ": 22, "ㅊ": 23, "ㅋ": 24, "ㅌ": 25, "ㅍ": 26, "ㅎ": 27 };

  const ARABIC_MULTI_MAP = [ ["allah", "الله"], ["sh", "ش"], ["kh", "خ"], ["gh", "غ"], ["th", "ث"], ["dh", "ذ"], ["ph", "ف"], ["ch", "تش"], ["aa", "ا"], ["ee", "ي"], ["ii", "ي"], ["oo", "و"], ["ou", "و"], ["ow", "او"], ["ya", "يا"], ["yo", "يو"], ["yu", "يو"], ["ei", "ي"], ["ai", "اي"], ["ay", "اي"], ["au", "او"] ];
  const HEBREW_MULTI_MAP = [ ["sh", "ש"], ["ch", "צ׳"], ["kh", "ח"], ["th", "ת"], ["ph", "פ"], ["aa", "א"], ["ee", "י"], ["ii", "י"], ["oo", "ו"], ["ou", "ו"], ["ow", "או"], ["ya", "יא"], ["yo", "יו"], ["yu", "יו"], ["ei", "י"], ["ai", "אי"], ["ay", "אי"], ["au", "או"] ];
  const BASIC_ARABIC_FALLBACK = { a: "ا", b: "ب", c: "ك", d: "د", e: "ي", f: "ف", g: "غ", h: "ه", i: "ي", j: "ج", k: "ك", l: "ل", m: "م", n: "ن", o: "و", p: "ب", q: "ق", r: "ر", s: "س", t: "ت", u: "و", v: "ف", w: "و", x: "كس", y: "ي", z: "ز" };
  const BASIC_HEBREW_FALLBACK = { a: "א", b: "ב", c: "ק", d: "ד", e: "א", f: "פ", g: "ג", h: "ה", i: "י", j: "ג'", k: "ק", l: "ל", m: "מ", n: "נ", o: "ו", p: "פ", q: "ק", r: "ר", s: "ס", t: "ט", u: "ו", v: "ב", w: "ו", x: "קס", y: "י", z: "ז" };

  // Which glossary parts a product actually needs. A Latin product needs none,
  // so it downloads nothing. Japanese needs both kana and kanji.
  const GLOSSARY_PARTS_FOR_SCRIPT = {
    arabic: ["arabic"],
    hebrew: ["hebrew"],
    korean: ["korean"],
    cyrillic: ["cyrillic"],
    japanese: ["kana", "kanji"],
    latin: [],
  };

  const glossaryPartState = {};   // part -> "loading" | "loaded"
  const glossaryPartPromises = {};

  async function fetchGlossaryPart(part) {
    if (glossaryPartState[part] === "loaded") return;
    if (glossaryPartPromises[part]) return glossaryPartPromises[part];

    const urls = window.gemiriaGlossaryUrls || {};
    const url = urls[part];
    if (!url) return;

    glossaryPartPromises[part] = (async () => {
      try {
        const res = await fetch(url);
        const data = await res.json();
        dynamicGlossary[part] = { ...dynamicGlossary[part], ...data };
        glossaryPartState[part] = "loaded";
      } catch (e) {
        console.error("Gemiria Glossary Load Error (" + part + "):", e);
      } finally {
        glossaryPartPromises[part] = null;
      }
    })();

    return glossaryPartPromises[part];
  }

  // Legacy path: one combined file. Kept so the site still works if the split
  // files are not configured yet.
  async function fetchLegacyGlossary() {
    if (glossaryLoaded || !window.gemiriaGlossaryUrl) return;
    if (glossaryPromise) return glossaryPromise;

    glossaryPromise = (async () => {
      try {
        const res = await fetch(window.gemiriaGlossaryUrl);
        const data = await res.json();
        dynamicGlossary = { ...dynamicGlossary, ...data };
        glossaryLoaded = true;
      } catch (e) {
        console.error("Gemiria Glossary Load Error:", e);
      } finally {
        glossaryPromise = null;
      }
    })();

    return glossaryPromise;
  }

  async function fetchGlossary(scriptFamily) {
    if (window.gemiriaGlossaryUrls) {
      const parts = GLOSSARY_PARTS_FOR_SCRIPT[scriptFamily] || GLOSSARY_PARTS_FOR_SCRIPT.latin;
      return Promise.all(parts.map(fetchGlossaryPart));
    }
    return fetchLegacyGlossary();
  }

  function getContext(el) { return el.closest(".quick-view") || el.closest(".product-page") || document; }
  function getWrapperForInput(input) {
    return input.closest("[data-gm-customization-root]") || input.closest(".gm-live-preview-host") || input.closest(".product-form__input") || input.closest(".product-form") || input.closest(".flex-1") || input.parentElement || getContext(input);
  }
  function getWrapperUid(wrapper) {
    if (!wrapperIds.has(wrapper)) { uniqueCounter += 1; wrapperIds.set(wrapper, `gm-${uniqueCounter}`); }
    return wrapperIds.get(wrapper);
  }

  function normalizeOptionName(name) { return (name || "").trim().toLowerCase(); }
  function normalizeLatin(value) {
    return (value || "").replace(/ß/g, "ss").replace(/ẞ/g, "ss").replace(/đ/g, "d").replace(/Đ/g, "D").replace(/ð/g, "d").replace(/Ð/g, "D").replace(/ł/g, "l").replace(/Ł/g, "L").replace(/þ/g, "th").replace(/Þ/g, "Th").replace(/æ/g, "ae").replace(/Æ/g, "Ae").replace(/œ/g, "oe").replace(/Œ/g, "Oe").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^A-Za-z\s'.-]/g, "").toLowerCase().trim();
  }
  function normalizeLookupKey(value) { return normalizeLatin(value).replace(/[^a-z]/g, ""); }
  function isLatinInput(value) { return /^[A-Za-zÀ-ÖØ-öø-ÿĀ-žĆćČčĐđŠšŽžÑñŁłßÆæŒœ\s'.-]+$/.test(value || ""); }
  function containsHiragana(value) { return /[\u3040-\u309F]/.test(value || ""); }
  function containsKatakana(value) { return /[\u30A0-\u30FF]/.test(value || ""); }
  function containsKanji(value) { return /[\u4E00-\u9FFF]/.test(value || ""); }
  function forceReflow(el) { void el.offsetWidth; }
  function splitNameParts(value) { return (value || "").split(/([\s'.-]+)/); }
  function convertWordByWord(value, converter) {
    return splitNameParts(value).map((part) => (/^[A-Za-zÀ-ÖØ-öø-ÿĀ-žĆćČčĐđŠšŽžÑñŁłßÆæŒœ]+$/.test(part) ? converter(part) : part)).join("");
  }

  function getSelectedOption(context, optionName) {
    const normalized = normalizeOptionName(optionName);
    const fieldsets = Array.from(context.querySelectorAll('#variant-picker fieldset[data-option-name], fieldset[data-option-name]'));
    const fieldset = fieldsets.find((fs) => normalizeOptionName(fs.getAttribute("data-option-name")) === normalized);
    if (fieldset) {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;
      const selectedButton = fieldset.querySelector('[aria-checked="true"], [data-selected="true"]');
      if (selectedButton) return selectedButton.getAttribute("data-value") || selectedButton.getAttribute("value") || selectedButton.textContent?.trim() || null;
    }
    return null;
  }

  function getProductMeta(wrapper) {
    const titleEl = wrapper.querySelector("[data-gm-product-title]");
    const rawTitle = (titleEl?.dataset.gmProductTitle || "").toLowerCase();
    const explicitScriptFamily = titleEl?.dataset.gmScriptFamily || wrapper.getAttribute("data-gm-script-family") || "";
    const explicitDefaultScript = titleEl?.dataset.gmDefaultScript || wrapper.getAttribute("data-gm-default-script") || "";
    let scriptFamily = explicitScriptFamily.toLowerCase().trim();

    if (!scriptFamily) {
      if (rawTitle.includes("arabic")) scriptFamily = "arabic";
      else if (rawTitle.includes("hebrew")) scriptFamily = "hebrew";
      else if (rawTitle.includes("korean")) scriptFamily = "korean";
      else if (rawTitle.includes("cyrillic")) scriptFamily = "cyrillic";
      else if (rawTitle.includes("japanese")) scriptFamily = "japanese";
      else scriptFamily = "latin";
    }

    return {
      title: rawTitle, scriptFamily, defaultScript: explicitDefaultScript || null,
      isNonLatin: ["arabic", "hebrew", "korean", "cyrillic", "japanese"].includes(scriptFamily)
    };
  }

  function inferFontFromMeta(meta, selectedScript = null) {
    if (meta.scriptFamily === "arabic") return "GM-Arabic";
    if (meta.scriptFamily === "hebrew") return "GM-Hebrew";
    if (meta.scriptFamily === "korean") return "GM-Korean";
    if (meta.scriptFamily === "cyrillic") return "GM-Cyrillic";
    if (meta.scriptFamily === "japanese") {
      if (selectedScript === "Hiragana") return "GM-Japanese-Hiragana";
      if (selectedScript === "Katakana") return "GM-Japanese-Katakana";
      if (selectedScript === "Kanji") return "GM-Japanese-Kanji";
      if (meta.defaultScript === "Katakana") return "GM-Japanese-Katakana";
      if (meta.defaultScript === "Kanji") return "GM-Japanese-Kanji";
      return "GM-Japanese-Hiragana";
    }
    return null;
  }

  function inferPlaceholder(meta, selectedScript = null, fieldName = "") {
    if (meta.scriptFamily === "arabic") return "الاسم";
    if (meta.scriptFamily === "hebrew") return "שם";
    if (meta.scriptFamily === "japanese") {
      if (selectedScript === "Katakana") return "カタカナ";
      if (selectedScript === "Kanji") return "漢字";
      return "ひらがな";
    }
    if (meta.scriptFamily === "korean") return "이름";
    if (meta.scriptFamily === "cyrillic") return "Имя";

    const fn = (fieldName || "").toLowerCase();
    const t = meta.title || "";

    // K-pop Bias & Your Name ring: idol field + your-name field.
    if (fn.includes("idol") || fn.includes("bias")) return "Hyunjin";
    if (t.includes("kpop") || t.includes("k-pop")) {
      if (fn.includes("your name") || fn.includes("second")) return "Katarina";
      return "Hyunjin";
    }

    // Couple ring: Meghan / Harry
    if (t.includes("couple")) {
      if (fn.includes("second")) return "Harry";
      return "Meghan";
    }

    // Best friends ring: Taylor / Selena
    if (t.includes("best friend")) {
      if (fn.includes("second")) return "Selena";
      return "Taylor";
    }

    // Family / three-name ring: keep the accented teaching names.
    if (t.includes("family") || t.includes("three name")) {
      if (fn.includes("first")) return "Zoë";
      if (fn.includes("second")) return "Chloé";
      if (fn.includes("third")) return "Lucía";
    }

    // Standard single-field Latin products: full 3-name set.
    return "Zoë / Chloé / Lucía";
  }

  /* ==========================================================
     Placeholder typewriter demo
     Types the existing preview placeholder character by
     character until the visitor interacts. Latin products
     with "Zoë / Chloé / Lucía" cycle the names one by one.
     Renders through renderPreviewTextSafely via
     updateVisualPreviewOnly, so font scaling, RTL, finish
     color, and the Safari repaint path all stay intact.
     ========================================================== */
  const DEMO_TYPE_MS = 120;
  const DEMO_HOLD_MULTI_MS = 1500;
  const DEMO_HOLD_SINGLE_MS = 2600;
  const DEMO_GAP_MS = 420;
  const demoStates = new WeakMap();
  let demoStartCounter = 0;
  const DEMO_REDUCED_MOTION = !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);

  // Optional override per script family with real verified names
  // instead of the generic placeholder word. Leave empty to type
  // the existing placeholders. Example:
  // arabic: ["ليلى", "مريم"], korean: ["리사", "지수"]
  // Verified names from the Gemiria glossary. These replace the
  // generic placeholder word ("name") in the typewriter demo, but
  // ONLY when the placeholder is that generic word, so field
  // specific placeholders like Hyunjin / Katarina stay untouched.
  const DEMO_NAMES_BY_FAMILY = {
    arabic: ["\u0644\u064A\u0644\u0649", "\u0645\u0627\u064A\u0627"],            // Layla, Maya
    hebrew: ["\u05DE\u05D0\u05D9\u05D4", "\u05DC\u05D9\u05D9\u05DC\u05D4"],      // Maya, Layla
    korean: ["\uB9AC\uC0AC", "\uC9C0\uC218"]                                     // Lisa, Jisoo
  };

  // Cyrillic demo names per language. Spellings taken verbatim from
  // the Gemiria glossary: Elena and Maria differ visibly across
  // Russian, Ukrainian, and Serbian, so the demo itself shows that
  // Cyrillic is not only Russian.
  const DEMO_NAMES_CYRILLIC = {
    ru: ["\u0415\u043B\u0435\u043D\u0430", "\u041C\u0430\u0440\u0438\u044F"],          // Елена, Мария
    uk: ["\u041E\u043B\u0435\u043D\u0430", "\u041C\u0430\u0440\u0456\u044F"],          // Олена, Марія
    sr: ["\u0408\u0435\u043B\u0435\u043D\u0430", "\u041C\u0430\u0440\u0438\u0458\u0430"], // Јелена, Марија
    bg: ["\u0415\u043B\u0435\u043D\u0430", "\u041C\u0430\u0440\u0438\u044F"]           // Елена, Мария
  };

  const DEMO_GENERIC_PLACEHOLDERS = {
    arabic: "\u0627\u0644\u0627\u0633\u0645",
    hebrew: "\u05E9\u05DD",
    korean: "\uC774\uB984",
    cyrillic: "\u0418\u043C\u044F"
  };

  function getDemoNames(placeholder) {
    return (placeholder || "").split("/").map((s) => s.trim()).filter(Boolean);
  }

  function resolveDemoNames(wrapper) {
    const meta = getProductMeta(wrapper);
    const input = wrapper.querySelector("input.customization-picker");
    const context = getContext(wrapper);
    const selectedScript = getSelectedOption(context, "script") || meta.defaultScript || (meta.scriptFamily === "japanese" ? "Hiragana" : null);
    const fieldName = input ? (input.getAttribute("name") || "") : "";
    const placeholderNames = getDemoNames(inferPlaceholder(meta, selectedScript, fieldName));

    // Cyrillic: pick names in the language currently selected in the
    // dropdown. Only when the placeholder is the generic word, so any
    // field-specific placeholder stays untouched.
    if (
      meta.scriptFamily === "cyrillic" &&
      placeholderNames.length === 1 &&
      placeholderNames[0] === DEMO_GENERIC_PLACEHOLDERS.cyrillic
    ) {
      const select = wrapper.querySelector(".gm-cyrillic-select");
      const langMap = { Russian: "ru", Ukrainian: "uk", Serbian: "sr", Bulgarian: "bg" };
      const lang = select ? (langMap[select.value] || "ru") : "ru";
      const cyrNames = DEMO_NAMES_CYRILLIC[lang];
      if (Array.isArray(cyrNames) && cyrNames.length) return cyrNames;
    }

    const familyNames = DEMO_NAMES_BY_FAMILY[meta.scriptFamily];
    const genericWord = DEMO_GENERIC_PLACEHOLDERS[meta.scriptFamily];
    if (
      Array.isArray(familyNames) && familyNames.length &&
      placeholderNames.length === 1 && placeholderNames[0] === genericWord
    ) {
      return familyNames;
    }
    return placeholderNames;
  }

  function demoIsActive(wrapper) {
    const s = demoStates.get(wrapper);
    return !!(s && !s.stopped);
  }

  function getDemoPartial(wrapper, names) {
    const s = demoStates.get(wrapper);
    if (!s || !names.length) return "";
    if (s.nameIdx >= names.length) s.nameIdx = 0;
    const chars = Array.from(names[s.nameIdx]);
    const count = Math.min(s.charIdx, chars.length);
    return chars.slice(0, count).join("");
  }

  function stopDemo(wrapper) {
    const s = demoStates.get(wrapper);
    if (!s || s.stopped) return;
    s.stopped = true;
    if (s.timer) clearTimeout(s.timer);
    const textEl = wrapper.querySelector("[data-gm-live-preview-text]");
    if (textEl) textEl.classList.remove("gm-demo-typing");
  }

  function demoTick(wrapper) {
    const s = demoStates.get(wrapper);
    if (!s || s.stopped) return;

    // Safety net: any real value anywhere kills the demo.
    const input = wrapper.querySelector("input.customization-picker");
    if (input && (input.value || "").trim()) { stopDemo(wrapper); handleMainInput(input); return; }
    const suggested = wrapper.querySelector(".gm-suggested-script__input");
    if (suggested && suggested.value.trim()) { stopDemo(wrapper); return; }

    const names = resolveDemoNames(wrapper);
    if (!names.length) { stopDemo(wrapper); return; }
    if (s.nameIdx >= names.length) s.nameIdx = 0;
    const chars = Array.from(names[s.nameIdx]);
    let nextDelay = DEMO_TYPE_MS;

    if (s.phase === "typing") {
      s.charIdx += 1;
      if (s.charIdx >= chars.length) {
        s.charIdx = chars.length;
        s.phase = "holding";
        nextDelay = names.length > 1 ? DEMO_HOLD_MULTI_MS : DEMO_HOLD_SINGLE_MS;
      }
    } else {
      // Hold finished: clear in one step and move to the next name.
      // A single clear per cycle means only one hard repaint per
      // cycle, exactly the path that already runs when a user
      // deletes text today.
      s.phase = "typing";
      s.charIdx = 0;
      s.nameIdx = (s.nameIdx + 1) % names.length;
      nextDelay = DEMO_GAP_MS;
    }

    updateVisualPreviewOnly(wrapper, getProductMeta(wrapper));
    s.timer = setTimeout(() => demoTick(wrapper), nextDelay);
  }

  function startDemoIfIdle(input) {
    if (DEMO_REDUCED_MOTION || !input) return;
    const wrapper = getWrapperForInput(input);
    if (demoStates.has(wrapper)) return;
    if (!wrapper.querySelector("[data-gm-live-preview-text]")) return;
    if ((input.value || "").trim()) return;
    const state = { stopped: false, nameIdx: 0, charIdx: 0, phase: "typing", timer: null };
    demoStates.set(wrapper, state);
    // Stagger multi-field products (couple, family, K-pop rings)
    // so two previews never type in creepy unison.
    const stagger = (demoStartCounter % 3) * 650;
    demoStartCounter += 1;
    state.timer = setTimeout(() => demoTick(wrapper), 700 + stagger);
  }

  function isRtlMeta(meta) { return meta.scriptFamily === "arabic" || meta.scriptFamily === "hebrew"; }
  function resolvePreviewFont(meta, selectedFont, selectedScript) {
    if (selectedFont && FONT_MAP[selectedFont]) return FONT_MAP[selectedFont];
    if (selectedScript && FONT_MAP[selectedScript]) return FONT_MAP[selectedScript];
    return inferFontFromMeta(meta, selectedScript) || "GM-Classic";
  }

  function computeFitScale(textEl) {
    const parent = textEl.parentElement; if (!parent) return 1;
    const cs = getComputedStyle(parent);
    const available = parent.clientWidth
      - (parseFloat(cs.paddingLeft) || 0)
      - (parseFloat(cs.paddingRight) || 0);

    let needed = textEl.scrollWidth;
    try {
      const range = document.createRange();
      range.selectNodeContents(textEl);
      const w = range.getBoundingClientRect().width;
      if (w > needed) needed = w;
    } catch (e) {}

    if (available > 0 && needed > available) return Math.max(0.6, available / needed);
    return 1;
  }

  function applyTransform(textEl, baseScale) {
    textEl.style.transform = "none";
    textEl.style.webkitTransform = "none";
    textEl.style.marginTop = "0px";
    textEl.style.marginBottom = "0px";

    forceReflow(textEl);

    const fitScale = computeFitScale(textEl);
    const ff = textEl.style.fontFamily || "";
    const y = FONT_Y_OFFSET[ff] ?? 0;
    const totalScale = baseScale * fitScale;
    const isRtl = textEl.classList.contains("is-rtl");

    if (totalScale !== 1) {
      // Scaled fonts: a margin would get visually swallowed by the
      // scale, so fold the vertical nudge into the transform as a
      // translateY. We divide y by the scale because translate INSIDE
      // scale() is multiplied by it, so this makes the on-screen shift
      // equal y pixels regardless of the scale factor. Positive y = down.
      const tx = y / totalScale;
      const transformValue = `scale(${totalScale}) translateY(${tx}px)`;
      textEl.style.transformOrigin = isRtl ? "center bottom" : "left bottom";
      textEl.style.transform = transformValue;
      textEl.style.webkitTransform = transformValue;
    } else if (y !== 0) {
      // Unscaled fonts (Silk): margins work normally and stay balanced
      // so the box height never changes. This is the case that's
      // already perfect, so it keeps doing exactly what it does now.
      textEl.style.marginTop = `${y}px`;
      textEl.style.marginBottom = `${-y}px`;
    }
  }

  function applyTransformWithRetry(textEl, baseScale) {
    applyTransform(textEl, baseScale);
    requestAnimationFrame(() => {
      applyTransform(textEl, baseScale);
      requestAnimationFrame(() => applyTransform(textEl, baseScale));
    });
    if (document.fonts && typeof document.fonts.ready?.then === "function") {
      document.fonts.ready.then(() => applyTransform(textEl, baseScale));
    }
  }

  function renderPreviewTextSafely(wrapper, textEl, displayText, fontFamily, selectedColor, baseScale) {
    const color = COLOR_MAP[selectedColor] || "currentColor";
    const shadow = getTextShadowForColor(selectedColor);
    const isRtl = textEl.classList.contains("is-rtl");

    const signature = [
      displayText,
      fontFamily,
      selectedColor,
      baseScale,
      isRtl ? "rtl" : "ltr"
    ].join("|");

    const previous = previewLastRender.get(wrapper);

    // If nothing actually changed, do nothing.
    // This stops the preview from jumping when you simply click around the product form.
    if (previous && previous.signature === signature) {
      return;
    }

    const fontChanged = !previous || previous.fontFamily !== fontFamily;
    const colorChanged = !previous || previous.selectedColor !== selectedColor;
    const textGotShorter = previous && displayText.length < previous.displayText.length;

    previewLastRender.set(wrapper, {
      signature,
      displayText,
      fontFamily,
      selectedColor
    });

    // Smooth path: when typing forward, do not clear and repaint everything.
    // This keeps the live preview feeling more premium.
    if (!fontChanged && !colorChanged && !textGotShorter) {
      textEl.style.transform = "none";
      textEl.style.webkitTransform = "none";
      textEl.style.fontFamily = fontFamily;
      applySilkClipFix(textEl, fontFamily);
      textEl.style.color = color;
      textEl.style.textShadow = shadow;
      textEl.textContent = displayText;
      // Hypothesis fix: defer the FIRST transform to the next frame
      // so mobile Safari has finished laying out the just-typed glyph
      // before we measure scrollWidth and apply the -6px nudge. This
      // mirrors what the delete path already does, and delete is the
      // case that renders correctly.
      requestAnimationFrame(() => applyTransformWithRetry(textEl, baseScale));
      return;
    }

    // Hard repaint path: needed for Safari mobile when deleting letters
    // or when font/color changes.
    const version = (previewPaintVersions.get(wrapper) || 0) + 1;
    previewPaintVersions.set(wrapper, version);

    textEl.style.transition = "none";
    textEl.style.transform = "none";
    textEl.style.webkitTransform = "none";
    textEl.style.opacity = "0.01";
    textEl.textContent = "";

    textEl.style.fontFamily = fontFamily;
    applySilkClipFix(textEl, fontFamily);
    textEl.style.color = color;
    textEl.style.textShadow = shadow;

    forceReflow(textEl);

    requestAnimationFrame(() => {
      if (previewPaintVersions.get(wrapper) !== version) return;

      textEl.textContent = displayText;
      forceReflow(textEl);

      applyTransform(textEl, baseScale);
      textEl.style.opacity = "1";

      requestAnimationFrame(() => {
        if (previewPaintVersions.get(wrapper) !== version) return;

        applyTransform(textEl, baseScale);
        textEl.style.transition = "";
      });

      if (document.fonts && typeof document.fonts.ready?.then === "function") {
        document.fonts.ready.then(() => {
          if (previewPaintVersions.get(wrapper) !== version) return;
          applyTransform(textEl, baseScale);
        });
      }
    });
  }

  function toKatakanaFromHiragana(text) { return text.replace(/[\u3041-\u3096]/g, (char) => String.fromCharCode(char.charCodeAt(0) + 0x60)); }
  function toHiraganaFromKatakana(text) { return text.replace(/[\u30A1-\u30F6]/g, (char) => String.fromCharCode(char.charCodeAt(0) - 0x60)); }

  function romanToKana(input) {
    let text = normalizeLatin(input); if (!text) return "";
    const directKey = text.replace(/[^a-z]/g, "");
    if (dynamicGlossary.kana[directKey]) return dynamicGlossary.kana[directKey];

    text = text.replace(/l/g, "r").replace(/x/g, "kusu").replace(/c(?=[eiy])/g, "s").replace(/c/g, "k").replace(/qu/g, "ku").replace(/v/g, "b");
    const map = [
      ["ltsu", "っ"], ["xtsu", "っ"], ["kya", "きゃ"], ["kyu", "きゅ"], ["kyo", "きょ"], ["gya", "ぎゃ"], ["gyu", "ぎゅ"], ["gyo", "ぎょ"], ["sha", "しゃ"], ["shu", "しゅ"], ["sho", "しょ"],
      ["sya", "しゃ"], ["syu", "しゅ"], ["syo", "しょ"], ["ja", "じゃ"], ["ju", "じゅ"], ["jo", "じょ"], ["jya", "じゃ"], ["jyu", "じゅ"], ["jyo", "じょ"], ["cha", "ちゃ"], ["chu", "ちゅ"], ["cho", "ちょ"],
      ["cya", "ちゃ"], ["cyu", "ちゅ"], ["cyo", "ちょ"], ["tya", "ちゃ"], ["tyu", "ちゅ"], ["tyo", "ちょ"], ["nya", "にゃ"], ["nyu", "にゅ"], ["nyo", "にょ"], ["hya", "ひゃ"], ["hyu", "ひゅ"], ["hyo", "ひょ"],
      ["bya", "びゃ"], ["byu", "びゅ"], ["byo", "びょ"], ["pya", "ぴゃ"], ["pyu", "ぴゅ"], ["pyo", "ぴょ"], ["mya", "みゃ"], ["myu", "みゅ"], ["myo", "みょ"], ["rya", "りゃ"], ["ryu", "りゅ"], ["ryo", "りょ"],
      ["fa", "ふぁ"], ["fi", "ふぃ"], ["fe", "ふぇ"], ["fo", "ふぉ"], ["tsa", "つぁ"], ["tsi", "つぃ"], ["tse", "つぇ"], ["tso", "つぉ"], ["she", "しぇ"], ["je", "じぇ"], ["che", "ちぇ"], ["ti", "てぃ"], ["tu", "とぅ"], ["di", "でぃ"], ["du", "どぅ"],
      ["shi", "し"], ["chi", "ち"], ["tsu", "つ"], ["fu", "ふ"], ["ji", "じ"], ["ka", "か"], ["ki", "き"], ["ku", "く"], ["ke", "け"], ["ko", "こ"], ["ga", "が"], ["gi", "ぎ"], ["gu", "ぐ"], ["ge", "げ"], ["go", "ご"],
      ["sa", "さ"], ["su", "す"], ["se", "せ"], ["so", "そ"], ["za", "ざ"], ["zi", "じ"], ["zu", "ず"], ["ze", "ぜ"], ["zo", "ぞ"], ["ta", "た"], ["te", "て"], ["to", "と"], ["da", "だ"], ["de", "で"], ["do", "ど"],
      ["na", "な"], ["ni", "に"], ["nu", "ぬ"], ["ne", "ね"], ["no", "の"], ["ha", "は"], ["hi", "ひ"], ["hu", "ふ"], ["he", "へ"], ["ho", "ほ"], ["ba", "ば"], ["bi", "び"], ["bu", "ぶ"], ["be", "べ"], ["bo", "ぼ"],
      ["pa", "ぱ"], ["pi", "ぴ"], ["pu", "ぷ"], ["pe", "ぺ"], ["po", "ぽ"], ["ma", "ま"], ["mi", "み"], ["mu", "む"], ["me", "め"], ["mo", "も"], ["ya", "や"], ["yu", "ゆ"], ["yo", "よ"], ["ra", "ら"], ["ri", "り"], ["ru", "る"], ["re", "れ"], ["ro", "ろ"],
      ["wa", "わ"], ["wi", "うぃ"], ["we", "うぇ"], ["wo", "を"], ["la", "ら"], ["li", "り"], ["lu", "る"], ["le", "れ"], ["lo", "ろ"], ["a", "あ"], ["i", "い"], ["u", "う"], ["e", "え"], ["o", "お"],
      
      // Permanent fallback sounds for lone consonants
      ["b", "ぶ"], ["c", "く"], ["d", "ど"], ["f", "ふ"], ["g", "ぐ"], ["h", "ふ"], ["j", "じ"], ["k", "く"], 
      ["l", "る"], ["m", "む"], ["p", "ぷ"], ["q", "く"], ["r", "る"], ["s", "す"], ["t", "と"], ["v", "ぶ"], 
      ["w", "う"], ["x", "くす"], ["y", "い"], ["z", "ず"]
    ];

    text = text.replace(/([bcdfghjklmpqrstvwxyz])\1/g, "っ$1"); text = text.replace(/n(?=b|m|p)/g, "ん"); text = text.replace(/n(?=[^aeiouy]|$)/g, "ん");
    let result = ""; let i = 0;
    while (i < text.length) {
      const char = text[i];
      if (char === " " || char === "'" || char === "-") { result += char; i += 1; continue; }
      let matched = false;
      for (const [roma, kana] of map) {
        if (text.slice(i, i + roma.length) === roma) { result += kana; i += roma.length; matched = true; break; }
      }
      if (!matched) { result += char === "r" && i === text.length - 1 ? "る" : char; i += 1; }
    }
    return result;
  }

  function convertKanjiWithMeta(value) {
    let matchedCount = 0; let totalWords = 0;
    const converted = splitNameParts(value).map((part) => {
      if (!/^[A-Za-zÀ-ÖØ-öø-ÿĀ-ž]+$/.test(part)) return part;
      totalWords += 1; const key = normalizeLookupKey(part); const mapped = dynamicGlossary.kanji[key];
      if (mapped) { matchedCount += 1; return mapped; } return "";
    }).join("").trim();
    return { value: converted, matchedCount, totalWords };
  }

  function convertJapanesePreview(value, selectedScript) {
    const trimmed = (value || "").trim(); if (!trimmed) return "";
    if (selectedScript === "Hiragana") {
      if (containsHiragana(trimmed)) return trimmed; if (containsKatakana(trimmed)) return toHiraganaFromKatakana(trimmed); if (containsKanji(trimmed)) return trimmed;
      if (isLatinInput(trimmed)) return convertWordByWord(trimmed, (word) => romanToKana(word));
      return trimmed;
    }
    if (selectedScript === "Katakana") {
      if (containsKatakana(trimmed)) return trimmed; if (containsHiragana(trimmed)) return toKatakanaFromHiragana(trimmed); if (containsKanji(trimmed)) return trimmed;
      if (isLatinInput(trimmed)) return convertWordByWord(trimmed, (word) => toKatakanaFromHiragana(romanToKana(word)));
      return trimmed;
    }
    if (selectedScript === "Kanji") {
      if (containsKanji(trimmed)) return trimmed; if (containsHiragana(trimmed) || containsKatakana(trimmed)) return trimmed;
      if (isLatinInput(trimmed)) {
        const kanjiMeta = convertKanjiWithMeta(trimmed);
        if (kanjiMeta.matchedCount > 0 && kanjiMeta.matchedCount === kanjiMeta.totalWords) return kanjiMeta.value;
        return convertWordByWord(trimmed, (word) => toKatakanaFromHiragana(romanToKana(word)));
      }
      return trimmed;
    }
    return trimmed;
  }

  function transliterateSerbianLatinToCyrillic(word) {
    const normalized = normalizeLatin(word); if (!normalized) return word;
    const digraphs = [[/dzh/g, "џ"], [/dz/g, "дз"], [/lj/g, "љ"], [/nj/g, "њ"], [/dj/g, "ђ"], [/ch/g, "ч"], [/sh/g, "ш"], [/zh/g, "ж"], [/ts/g, "ц"], [/kh/g, "х"], [/ya/g, "ја"], [/yu/g, "ју"], [/yo/g, "јо"], [/ye/g, "је"]];
    let text = normalized; digraphs.forEach(([pattern, replacement]) => { text = text.replace(pattern, replacement); });
    const single = { a: "а", b: "б", c: "ц", d: "д", e: "е", f: "ф", g: "г", h: "х", i: "и", j: "ј", k: "к", l: "л", m: "м", n: "н", o: "о", p: "п", q: "к", r: "р", s: "с", t: "т", u: "у", v: "в", w: "в", x: "кс", y: "и", z: "з" };
    const converted = text.split("").map((char) => single[char] || char).join("");
    return converted ? converted.charAt(0).toUpperCase() + converted.slice(1) : converted;
  }

  function convertCyrillicWord(word, langCode) {
    const key = normalizeLookupKey(word); if (!key) return word;
    if (dynamicGlossary.cyrillic[key] && dynamicGlossary.cyrillic[key][langCode]) return dynamicGlossary.cyrillic[key][langCode];
    if (langCode === "sr") return transliterateSerbianLatinToCyrillic(word);
    const fallbackMap = BASIC_CYRILLIC_FALLBACK[langCode] || BASIC_CYRILLIC_FALLBACK.ru;
    const text = key.split("").map((c) => fallbackMap[c] || c).join("");
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : text;
  }

  function convertCyrillicPreview(value, langCode) {
    const trimmed = (value || "").trim(); if (!trimmed) return ""; if (!isLatinInput(trimmed)) return trimmed;
    return convertWordByWord(trimmed, (word) => convertCyrillicWord(word, langCode));
  }

  function isHangulVowel(jamo) { return Object.prototype.hasOwnProperty.call(HANGUL_MEDIALS, jamo); }
  function isHangulConsonant(jamo) { return Object.prototype.hasOwnProperty.call(HANGUL_INITIALS, jamo); }
  function composeHangulSyllable(initial, medial, final = "") {
    if (!Object.prototype.hasOwnProperty.call(HANGUL_INITIALS, initial) || !Object.prototype.hasOwnProperty.call(HANGUL_MEDIALS, medial) || !Object.prototype.hasOwnProperty.call(HANGUL_FINALS, final)) return initial + medial + final;
    const code = 0xac00 + HANGUL_INITIALS[initial] * 21 * 28 + HANGUL_MEDIALS[medial] * 28 + HANGUL_FINALS[final]; return String.fromCharCode(code);
  }

  function latinToKoreanJamo(word) {
    let text = normalizeLatin(word).replace(/[^a-z]/g, ""); if (!text) return "";
    BASIC_KOREAN_MULTI_MAP.forEach(([from, to]) => { text = text.split(from).join(to); });
    let jamo = ""; for (const ch of text) { jamo += BASIC_KOREAN_SINGLE_MAP[ch] || ch; } return jamo;
  }

  function jamoToHangul(jamoText) {
    const chars = [...jamoText]; let result = ""; let i = 0;
    while (i < chars.length) {
      let initial = chars[i]; let medial = chars[i + 1]; let final = "";
      if (isHangulVowel(initial)) { initial = "ㅇ"; medial = chars[i]; i -= 1; }
      if (!isHangulConsonant(initial) || !isHangulVowel(medial)) { result += chars[i]; i += 1; continue; }
      const next = chars[i + 2]; const afterNext = chars[i + 3];
      if (next && isHangulConsonant(next) && (!afterNext || !isHangulVowel(afterNext))) { final = next; result += composeHangulSyllable(initial, medial, final); i += 3; continue; }
      result += composeHangulSyllable(initial, medial, ""); i += 2;
    }
    return result;
  }

  function convertKoreanWord(word) {
    const key = normalizeLookupKey(word); if (!key) return word;
    if (dynamicGlossary.korean[key]) return dynamicGlossary.korean[key];
    return jamoToHangul(latinToKoreanJamo(word)) || word;
  }

  function convertKoreanPreview(value) {
    const trimmed = (value || "").trim(); if (!trimmed) return ""; if (!isLatinInput(trimmed)) return trimmed;
    return convertWordByWord(trimmed, (word) => convertKoreanWord(word));
  }

  // ---- Phonetic-fallback spelling rules -------------------------------
  // These ONLY run when a name is not in the glossary. A glossary hit never
  // reaches this code, so any spelling that is correct today stays correct.
  const LATIN_CONSONANTS = "bcdfghjklmnpqrstvwxyz";
  const DOUBLE_CONSONANT_RE = /([bcdfghjklmnpqrstvwxyz])\1+/g;

  // Shared Latin clean-up before either script is mapped.
  //   1. Collapse doubled consonants. Arabic and Hebrew write a doubled
  //      consonant once, so "Starr" is ستار not ستارر.
  //   2. Soft c before e/i/y is an s sound ("Grace"), hard c is a k.
  //   3. Drop a silent final e after a consonant ("Isabelle", "Grace"),
  //      but keep the "ie" ending, which is a real vowel ("Sophie").
  function prepLatinForScript(text) {
    let out = text.replace(DOUBLE_CONSONANT_RE, "$1");
    out = out.replace(/c(?=[eiy])/g, "s").replace(/c/g, "k");
    if (out.length > 2 && out.slice(-1) === "e" && LATIN_CONSONANTS.indexOf(out.slice(-2, -1)) !== -1) {
      out = out.slice(0, -1);
    }
    return out;
  }

  // Arabic cannot open a word on a bare yaa or waw acting as a vowel, it
  // needs a carrier alif. "Ibrahim" is إبراهيم, never يبراهيم.
  function addArabicInitialCarrier(result, firstLetter) {
    if (!result) return result;
    if ((firstLetter === "i" || firstLetter === "e") && result.charAt(0) === "\u064a") {
      return "\u0625\u064a" + result.slice(1);
    }
    if ((firstLetter === "o" || firstLetter === "u") && result.charAt(0) === "\u0648") {
      return "\u0623\u0648" + result.slice(1);
    }
    return result;
  }

  // Arabic writes long /aa/ with an alif but leaves short /a/ unwritten. A Latin
  // "a" is ambiguous between the two, so mapping every one of them to an alif
  // produced ماهدي for Mahdi and جامال for Jamal. Measured against the 1053
  // verified pairs in the glossary, the best available heuristic is to keep only
  // the LAST medial "a" of a word and drop any earlier ones, which turns Jamal
  // into جمال and Salam into سلام correctly. Word-initial and word-final "a" are
  // left alone, and any "a" already consumed by ARABIC_MULTI_MAP (aa, ai, ay,
  // ya, au) is untouched because those pairs carry their own vowel length.
  function dropShortMedialA(text) {
    const chars = text.split("");
    const last = chars.length - 1;
    const medial = [];
    for (let i = 1; i < last; i += 1) {
      if (chars[i] !== "a") continue;
      if (chars[i - 1] === "a" || chars[i + 1] === "a") continue;
      medial.push(i);
    }
    for (let i = 0; i < medial.length - 1; i += 1) chars[medial[i]] = "";
    return chars.join("");
  }

  function transliterateArabicWord(word) {
    const normalized = normalizeLookupKey(word); if (!normalized) return word;
    const firstLetter = normalized.charAt(0);
    let text = prepLatinForScript(normalized);
    text = dropShortMedialA(text);
    ARABIC_MULTI_MAP.forEach(([from, to]) => { text = text.split(from).join(to); });
    let result = "";
    for (let i = 0; i < text.length; i += 1) {
      const char = text[i];
      if (/[a-z]/.test(char)) result += BASIC_ARABIC_FALLBACK[char] || char; else result += char;
    }
    return addArabicInitialCarrier(result, firstLetter);
  }

  // Five Hebrew letters take a different shape at the end of a word. Without
  // this, "Miriam" renders מיריאמ instead of מרים, which reads as broken to
  // anyone who can read Hebrew.
  const HEBREW_FINAL_FORMS = { "\u05DB": "\u05DA", "\u05DE": "\u05DD", "\u05E0": "\u05DF", "\u05E4": "\u05E3", "\u05E6": "\u05E5" };
  const HEBREW_GERESH = ["\u05F3", "\u05F4", "'"];
  function applyHebrewFinalForm(value) {
    if (!value) return value;
    let i = value.length - 1;
    // A geresh sits after the letter (ג', צ׳), so step back past it first.
    while (i >= 0 && HEBREW_GERESH.indexOf(value.charAt(i)) !== -1) i -= 1;
    if (i < 0) return value;
    const letter = value.charAt(i);
    if (!HEBREW_FINAL_FORMS[letter]) return value;
    return value.slice(0, i) + HEBREW_FINAL_FORMS[letter] + value.slice(i + 1);
  }

  function transliterateHebrewWord(word) {
    const normalized = normalizeLookupKey(word); if (!normalized) return word;
    let text = normalized.replace(DOUBLE_CONSONANT_RE, "$1");
    text = text.replace(/c(?=[eiy])/g, "s").replace(/c/g, "k");

    // A name ending in -a or -ah takes a final he ("Shira" שירה, "Malka" מלכה).
    let needsFinalHe = false;
    if (text.slice(-2) === "ah") { text = text.slice(0, -2); needsFinalHe = true; }
    else if (text.slice(-1) === "a") { text = text.slice(0, -1); needsFinalHe = true; }
    else if (text.length > 2 && text.slice(-1) === "e" && LATIN_CONSONANTS.indexOf(text.slice(-2, -1)) !== -1) {
      text = text.slice(0, -1);
    }

    HEBREW_MULTI_MAP.forEach(([from, to]) => { text = text.split(from).join(to); });
    let result = "";
    for (let i = 0; i < text.length; i += 1) {
      const char = text[i];
      if (/[a-z]/.test(char)) result += BASIC_HEBREW_FALLBACK[char] || char; else result += char;
    }
    if (needsFinalHe) result += "\u05D4";
    return applyHebrewFinalForm(result);
  }

  // Deliberately NOT implemented: dropping internal short vowels. It is right
  // for Hebrew-origin names (Tamar -> תמר) and wrong for foreign ones
  // (Starr -> סטאר, not סטר). That split belongs in the glossary, not in a rule.

  // Records how the spelling on the order was arrived at, so every order
  // arrives labelled and low-confidence ones can be reviewed before production.
  //   glossary      = verified lookup table hit, high confidence
  //   phonetic      = rule-based guess, NEEDS A HUMAN CHECK
  //   kanji-fallback= no Kanji entry, fell back to Katakana
  //   native-script = customer typed/pasted the script themselves
  //   user-edited   = customer overrode whatever we suggested
  const SOURCE_LABELS = {
    glossary: "glossary",
    phonetic: "phonetic",
    kanji_fallback: "kanji-fallback",
    review: "native-script",
    neutral: ""
  };
  function setSpellingSource(wrapper, source) {
    const box = wrapper.querySelector(".gm-suggested-script");
    const field = wrapper.querySelector(".gm-spelling-source");
    const label = Object.prototype.hasOwnProperty.call(SOURCE_LABELS, source) ? SOURCE_LABELS[source] : source;
    if (field) field.value = label || "";
    if (box) {
      if (label) box.setAttribute("data-gm-spelling-source", label);
      else box.removeAttribute("data-gm-spelling-source");
    }
  }

  function ensureStatusLine(wrapper) {
    let status = wrapper.querySelector(".gm-suggested-script__status");
    if (!status) { status = document.createElement("p"); status.className = "gm-suggested-script__status"; }
    return status;
  }

  function setStatus(wrapper, text, variant = "neutral") {
    const status = wrapper.querySelector(".gm-suggested-script__status"); if (!status) return;
    status.textContent = text || ""; status.setAttribute("data-status-variant", variant);
  }

  function toggleSuggestedScriptBox(wrapper, shouldShow) {
    const box = wrapper.querySelector(".gm-suggested-script"); if (!box) return; box.style.display = shouldShow ? "block" : "none";
  }

  function applyStatus(box, type = "neutral") {
    const entry = STATUS_MESSAGES[type] || STATUS_MESSAGES.neutral; setStatus(box, entry.text, entry.variant);
  }

  function getSuggestedLabel(meta, selectedScript, cyrillicLang) {
    if (meta.scriptFamily === "japanese") {
      if (selectedScript === "Hiragana") return "Suggested Hiragana spelling"; if (selectedScript === "Katakana") return "Suggested Katakana spelling"; if (selectedScript === "Kanji") return "Suggested Kanji spelling"; return "Suggested Japanese spelling";
    }
    if (meta.scriptFamily === "korean") return "Suggested Korean spelling";
    if (meta.scriptFamily === "arabic") return "Suggested Arabic spelling";
    if (meta.scriptFamily === "hebrew") return "Suggested Hebrew spelling";
    if (meta.scriptFamily === "cyrillic") {
      const labels = { ru: "Suggested Russian spelling", uk: "Suggested Ukrainian spelling", sr: "Suggested Serbian spelling", bg: "Suggested Bulgarian spelling" };
      return labels[cyrillicLang || "ru"] || "Suggested Cyrillic spelling";
    }
    return "Suggested spelling";
  }

  function ensureCyrillicSelector(wrapper, meta) {
    if (meta.scriptFamily !== "cyrillic") { wrapper.querySelector(".gm-cyrillic-selector-wrapper")?.remove(); return "ru"; }
    let selectorWrapper = wrapper.querySelector(".gm-cyrillic-selector-wrapper");
    const uid = getWrapperUid(wrapper); const selectId = `${uid}-gm-cyrillic-lang`;

    if (!selectorWrapper) {
      selectorWrapper = document.createElement("div"); selectorWrapper.className = "gm-cyrillic-selector-wrapper";
      selectorWrapper.innerHTML = `
        <label for="${selectId}" class="gm-live-preview__label">Choose your language</label>
        <div class="gm-cyrillic-select-container">
          <select id="${selectId}" class="gm-cyrillic-select" name="properties[Cyrillic Language]">
            <option value="Russian">Russian (Русский)</option>
            <option value="Ukrainian">Ukrainian (Українська)</option>
            <option value="Serbian">Serbian (Српски)</option>
            <option value="Bulgarian">Bulgarian (Български)</option>
          </select>
        </div>
      `;
      const inputEl = wrapper.querySelector("input.customization-picker");
      if (inputEl && inputEl.parentNode) inputEl.parentNode.insertBefore(selectorWrapper, inputEl); else wrapper.prepend(selectorWrapper);
      selectorWrapper.querySelector("select").addEventListener("change", () => {
        const customInput = wrapper.querySelector("input.customization-picker"); if (customInput) handleMainInput(customInput);
      });
    }
    const selectedValue = selectorWrapper.querySelector("select").value;
    const langMap = { Russian: "ru", Ukrainian: "uk", Serbian: "sr", Bulgarian: "bg" }; return langMap[selectedValue] || "ru";
  }

  function ensureDisclaimer(wrapper) {
    if (!wrapper.querySelector(".gm-live-preview__disclaimer")) {
      const previewBlock = wrapper.querySelector(".gm-live-preview") || wrapper; const disclaimer = document.createElement("div"); disclaimer.className = "gm-live-preview__disclaimer";
      disclaimer.innerHTML = `
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gm-live-preview__disclaimer-icon">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
        </svg>
        <span>We will always review and verify the linguistic accuracy before crafting your jewelry.</span>
      `;
      previewBlock.appendChild(disclaimer);
    }
  }

  function ensureSuggestedScriptBox(wrapper, meta, selectedScript, cyrillicLang) {
    if (!meta.isNonLatin) { wrapper.querySelector(".gm-suggested-script")?.remove(); return null; }
    let box = wrapper.querySelector(".gm-suggested-script");
    const uid = getWrapperUid(wrapper); const inputId = `${uid}-gm-suggested-script-input`;
    const inputEl = wrapper.querySelector("input.customization-picker");
    const formAttr = inputEl && inputEl.hasAttribute("form") ? `form="${inputEl.getAttribute("form")}"` : "";

    if (!box) {
      box = document.createElement("div"); box.className = "gm-suggested-script";
      box.innerHTML = `
        <label class="gm-live-preview__label" for="${inputId}">${getSuggestedLabel(meta, selectedScript, cyrillicLang)}</label>
        <input type="search" inputmode="text" id="${inputId}" name="properties[Suggested Spelling]" class="gm-suggested-script__input" placeholder="Suggested spelling appears here" dir="auto" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" data-lpignore="true" data-1p-ignore="true" ${formAttr} />
        <input type="hidden" name="properties[_Spelling Source]" class="gm-spelling-source" value="" ${formAttr} />
        <p class="gm-suggested-script__status" data-status-variant="neutral"></p>
      `;
      if (inputEl && inputEl.parentNode) inputEl.parentNode.insertBefore(box, inputEl.nextSibling); else wrapper.appendChild(box);
      const suggestedInput = box.querySelector("input"); suggestedInput.addEventListener("input", () => {
        const engineValue = engineSuggestions.get(wrapper);
        const typed = suggestedInput.value.trim();
        if (typed && engineValue && typed !== engineValue.value) setSpellingSource(wrapper, "user-edited");
        else if (engineValue) setSpellingSource(wrapper, engineValue.source);
        updateVisualPreviewOnly(wrapper, meta);
      });
    } else {
      const label = box.querySelector("label"); if (label) label.textContent = getSuggestedLabel(meta, selectedScript, cyrillicLang);
    }

    const suggestedInput = box.querySelector("input"); const status = ensureStatusLine(box);
    if (!status.parentNode) box.appendChild(status); box.style.display = "block"; return suggestedInput;
  }

  // ---- Glyph coverage guard -------------------------------------------
  // Verified by reading the shipped font files. A character the font does not
  // contain still LOOKS fine in the browser, because the browser quietly
  // substitutes another typeface, but the production file has nothing to cut.
  // This catches that before the order is placed.
  // ---- Glyph coverage guard -------------------------------------------
  // Built by reading the cmap table of the shipped Latin font files. A missing
  // character still LOOKS right in the browser because the browser quietly
  // substitutes another typeface, but the production file has nothing to cut.
  // Latin fonts only. Non-Latin scripts are deliberately not guarded until
  // their deployed webfonts are confirmed against the source files.
  const FONT_GLYPH_COVERAGE = {
    "GM-Classic": "ªµºÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿĀāĂăĄąĆćĈĉĊċČčĎďĐđĒēĔĕĖėĘęĚěĜĝĞğĠġĢģĤĥĦħĨĩĪīĬĭĮįİıĲĳĴĵĶķĸĹĺĻļĽľĿŀŁłŃńŅņŇňŉŊŋŌōŎŏŐőŒœŔŕŖŗŘřŚśŜŝŞşŠšŢţŤťŦŧŨũŪūŬŭŮůŰűŲųŴŵŶŷŸŹźŻżŽžſƒǺǻǼǽǾǿˆˇˉΆΈΉΊΌΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώЁЂЃЄЅІЇЈЉЊЋЌЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюяёђѓєѕіїјљњћќўџҐґẀẁẂẃẄẅỲỳⁿℓΩ",
    "GM-Royal": "ªµºÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿıŁłŒœŠšŸŽžƒˆˇˉΔΩμπΩ",
    "GM-Silk": "ÄÖØÜßäæíöøü",
    "GM-Vibe": "ªµºÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿıŒœŠšŸŽž",
    "GM-Romance": "ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýÿŁłŒœŠšŸŽžƒˆˇ"
  };

  const LATIN_FONT_LABELS = { "GM-Classic": "Classic", "GM-Royal": "Royal", "GM-Silk": "Silk", "GM-Romance": "Romance", "GM-Vibe": "Vibe" };

  function findUnsupportedChars(text, fontFamily) {
    const supported = FONT_GLYPH_COVERAGE[fontFamily];
    if (!supported || !text) return [];       // font not audited -> stay silent
    const missing = [];
    for (const ch of text) {
      if (ch.codePointAt(0) < 0x80) continue; // plain ASCII is always present
      if (supported.indexOf(ch) === -1 && missing.indexOf(ch) === -1) missing.push(ch);
    }
    return missing;
  }

  function fontsThatSupport(chars, currentFamily) {
    if (!LATIN_FONT_LABELS[currentFamily]) return [];
    return Object.keys(LATIN_FONT_LABELS)
      .filter((fam) => FONT_GLYPH_COVERAGE[fam] && chars.every((ch) => FONT_GLYPH_COVERAGE[fam].indexOf(ch) !== -1))
      .map((fam) => LATIN_FONT_LABELS[fam]);
  }

  function updateCoverageNotice(wrapper, text, fontFamily) {
    let note = wrapper.querySelector(".gm-font-coverage-note");
    const missing = findUnsupportedChars(text, fontFamily);
    if (!missing.length) { if (note) note.remove(); return; }
    if (!note) {
      note = document.createElement("p");
      note.className = "gm-font-coverage-note";
      // Must live INSIDE the .gm-live-preview card. On desktop the wrapper is a
      // CSS grid with fixed column assignments, so an unplaced child there would
      // auto-flow into the preview column and break the layout.
      const card = wrapper.querySelector(".gm-live-preview");
      if (!card) return;
      const disclaimer = card.querySelector(".gm-live-preview__disclaimer");
      if (disclaimer) card.insertBefore(note, disclaimer); else card.appendChild(note);
    }
    const alt = fontsThatSupport(missing, fontFamily);
    const here = LATIN_FONT_LABELS[fontFamily] || "this font";
    const shown = missing.slice(0, 3).map((ch) => `"${ch}"`).join(", ");
    const chars = missing.length > 3 ? `${shown} and ${missing.length - 3} more` : shown;
    const isPlural = missing.length > 1;
    const altList = alt.length > 1 ? alt.slice(0, -1).join(", ") + " or " + alt[alt.length - 1] : alt[0];
    note.textContent = alt.length
      ? `${chars} ${isPlural ? "aren't" : "isn't"} available in ${here}. Switch to ${altList} to keep it exactly right.`
      : `We can't set ${chars} in any of our fonts yet. Message us and we will find the closest match with you.`;
  }

  function resolveSuggestedSpelling(meta, selectedScript, value, cyrillicLang) {
    const trimmed = (value || "").trim(); if (!trimmed) return { value: "", source: "neutral" };
    if (!isLatinInput(trimmed)) return { value: "", source: "review" };

    if (meta.scriptFamily === "japanese") {
      if (selectedScript === "Kanji") {
        const kanjiMeta = convertKanjiWithMeta(trimmed);
        if (kanjiMeta.matchedCount > 0 && kanjiMeta.matchedCount === kanjiMeta.totalWords) return { value: kanjiMeta.value, source: "glossary" };
        const katakanaFallback = convertJapanesePreview(trimmed, "Katakana"); return { value: katakanaFallback, source: "kanji_fallback" };
      }
      const converted = convertJapanesePreview(trimmed, selectedScript || "Hiragana");
      const hasGlossaryHit = splitNameParts(trimmed).some((part) => {
        if (!/^[A-Za-zÀ-ÖØ-öø-ÿĀ-žĆćČčĐđŠšŽžÑñŁłßÆæŒœ]+$/.test(part)) return false; return !!dynamicGlossary.kana[normalizeLookupKey(part)];
      });
      return { value: converted, source: hasGlossaryHit ? "glossary" : "phonetic" };
    }

    if (meta.scriptFamily === "korean") {
      const converted = convertKoreanPreview(trimmed);
      const hasGlossaryHit = splitNameParts(trimmed).some((part) => {
        if (!/^[A-Za-zÀ-ÖØ-öø-ÿĀ-žĆćČčĐđŠšŽžÑñŁłßÆæŒœ]+$/.test(part)) return false; return !!dynamicGlossary.korean[normalizeLookupKey(part)];
      });
      return { value: converted, source: hasGlossaryHit ? "glossary" : "phonetic" };
    }

    if (meta.scriptFamily === "arabic") {
      let usedGlossary = false;
      const converted = splitNameParts(trimmed).map((part) => {
        if (!/^[A-Za-zÀ-ÖØ-öø-ÿĀ-žĆćČčĐđŠšŽžÑñŁłßÆæŒœ]+$/.test(part)) return part;
        const key = normalizeLookupKey(part);
        if (dynamicGlossary.arabic[key]) { usedGlossary = true; return dynamicGlossary.arabic[key]; }
        return transliterateArabicWord(part);
      }).join("");
      return { value: converted, source: usedGlossary ? "glossary" : "phonetic" };
    }

    if (meta.scriptFamily === "hebrew") {
      let usedGlossary = false;
      const converted = splitNameParts(trimmed).map((part) => {
        if (!/^[A-Za-zÀ-ÖØ-öø-ÿĀ-žĆćČčĐđŠšŽžÑñŁłßÆæŒœ]+$/.test(part)) return part;
        const key = normalizeLookupKey(part);
        if (dynamicGlossary.hebrew[key]) { usedGlossary = true; return dynamicGlossary.hebrew[key]; }
        return transliterateHebrewWord(part);
      }).join("");
      return { value: converted, source: usedGlossary ? "glossary" : "phonetic" };
    }

    if (meta.scriptFamily === "cyrillic") {
      let usedGlossary = false;
      const converted = splitNameParts(trimmed).map((part) => {
        if (!/^[A-Za-zÀ-ÖØ-öø-ÿĀ-žĆćČčĐđŠšŽžÑñŁłßÆæŒœ]+$/.test(part)) return part;
        const key = normalizeLookupKey(part);
        if (dynamicGlossary.cyrillic[key]?.[cyrillicLang || "ru"]) { usedGlossary = true; return dynamicGlossary.cyrillic[key][cyrillicLang || "ru"]; }
        return convertCyrillicWord(part, cyrillicLang || "ru");
      }).join("");
      return { value: converted, source: usedGlossary ? "glossary" : "phonetic" };
    }

    return { value: trimmed, source: "review" };
  }

  function getTextShadowForColor(selectedColor) {
    if (selectedColor === "18K Gold") {
      return "0 1px 0 rgba(255,255,255,0.35), 0 1px 2px rgba(120,90,20,0.12)";
    }

    if (selectedColor === "Rhodium Silver") {
      return "0 1px 0 rgba(255,255,255,0.45), 0 1px 2px rgba(0,0,0,0.12)";
    }

    if (selectedColor === "18K Rose Gold") {
      return "0 1px 0 rgba(255,255,255,0.35), 0 1px 2px rgba(120,60,45,0.12)";
    }

    return "none";
  }

  function updateVisualPreviewOnly(wrapper, meta) {
    const context = getContext(wrapper);
    const textEl = wrapper.querySelector("[data-gm-live-preview-text]");
    if (!textEl) return;

    const selectedFont = getSelectedOption(context, "font");
    const selectedScript = getSelectedOption(context, "script") || meta.defaultScript || (meta.scriptFamily === "japanese" ? "Hiragana" : null);
    const selectedColor = normalizeFinish(getSelectedOption(context, "finish"));

    const previewBox = wrapper.querySelector(".gm-live-preview");
    if (previewBox) {
      previewBox.classList.remove("is-gold", "is-silver", "is-rose");

      if (selectedColor === "18K Gold") {
        previewBox.classList.add("is-gold");
      } else if (selectedColor === "Rhodium Silver") {
        previewBox.classList.add("is-silver");
      } else if (selectedColor === "18K Rose Gold") {
        previewBox.classList.add("is-rose");
      }
    }

    const suggestedInput = wrapper.querySelector(".gm-suggested-script__input");
    const originalInput = wrapper.querySelector("input.customization-picker");
    let displayValue = "";

    if (suggestedInput && suggestedInput.offsetParent !== null && suggestedInput.value.trim() !== "") {
      displayValue = suggestedInput.value.trim();
    } else if (originalInput) {
      displayValue = originalInput.value.trim();
    }

    if (meta.scriptFamily === "japanese" && originalInput && !suggestedInput?.value.trim()) displayValue = convertJapanesePreview(originalInput.value, selectedScript || "Hiragana");
    if (meta.scriptFamily === "cyrillic" && originalInput && !suggestedInput?.value.trim()) { const langCode = ensureCyrillicSelector(wrapper, meta); displayValue = convertCyrillicPreview(originalInput.value, langCode); }
    if (meta.scriptFamily === "korean" && originalInput && !suggestedInput?.value.trim()) displayValue = convertKoreanPreview(originalInput.value);

    const fieldName = originalInput ? (originalInput.getAttribute("name") || "") : "";
    const placeholder = inferPlaceholder(meta, selectedScript, fieldName);

    let finalPreviewText = displayValue || placeholder;
    let isDemoFrame = false;

    // While the typewriter demo owns the empty state, render the
    // current partial instead of the static placeholder. Variant
    // changes (finish, script, font) land here too, so the demo
    // picks up new selections mid-animation.
    if (!displayValue && demoIsActive(wrapper)) {
      finalPreviewText = getDemoPartial(wrapper, resolveDemoNames(wrapper));
      isDemoFrame = true;
    }

    textEl.classList.toggle("gm-demo-typing", isDemoFrame);
    textEl.classList.toggle("is-rtl", isRtlMeta(meta));

    const fontFamily = resolvePreviewFont(meta, selectedFont, selectedScript);
    const baseScale = FONT_SCALE[fontFamily] ?? 1;

    updateCoverageNotice(wrapper, finalPreviewText, fontFamily);

    renderPreviewTextSafely(wrapper, textEl, finalPreviewText, fontFamily, selectedColor, baseScale);
  }

  function scheduleInputProcessing(input, task) {
    const wrapper = getWrapperForInput(input);
    const existingTimer = debounceTimers.get(wrapper); if (existingTimer) clearTimeout(existingTimer);
    const timer = setTimeout(task, TYPING_INTERVAL); debounceTimers.set(wrapper, timer);
  }

  function handleMainInput(input) {
    if (!input) return;
    const wrapper = getWrapperForInput(input); const meta = getProductMeta(wrapper); const rawValue = (input.value || "").trim();
    const cyrillicLang = ensureCyrillicSelector(wrapper, meta);

    if (!rawValue) {
      const suggestedInput = wrapper.querySelector(".gm-suggested-script__input"); if (suggestedInput) suggestedInput.value = "";
      engineSuggestions.delete(wrapper);
      setSpellingSource(wrapper, "neutral");
      toggleSuggestedScriptBox(wrapper, false);
      if (wrapper.querySelector(".gm-suggested-script")) applyStatus(wrapper.querySelector(".gm-suggested-script"), "neutral");
      updateVisualPreviewOnly(wrapper, meta); return;
    }

    stopDemo(wrapper);

    if (!meta.isNonLatin) { updateVisualPreviewOnly(wrapper, meta); return; }

    ensureDisclaimer(wrapper);
    const context = getContext(input);
    const selectedScript = getSelectedOption(context, "script") || meta.defaultScript || (meta.scriptFamily === "japanese" ? "Hiragana" : null);
    const suggestedInput = ensureSuggestedScriptBox(wrapper, meta, selectedScript, cyrillicLang);

    if (!suggestedInput) { updateVisualPreviewOnly(wrapper, meta); return; }
    if (!isLatinInput(rawValue)) {
      suggestedInput.value = ""; engineSuggestions.delete(wrapper); setSpellingSource(wrapper, "native-script"); toggleSuggestedScriptBox(wrapper, false); updateVisualPreviewOnly(wrapper, meta); return;
    }

    toggleSuggestedScriptBox(wrapper, true);

    scheduleInputProcessing(input, () => {
      const result = resolveSuggestedSpelling(meta, selectedScript, rawValue, cyrillicLang);
      engineSuggestions.set(wrapper, { value: (result.value || "").trim(), source: result.source || "neutral" });
      suggestedInput.value = result.value || ""; applyStatus(wrapper.querySelector(".gm-suggested-script"), result.source || "neutral");
      setSpellingSource(wrapper, result.source || "neutral");
      updateVisualPreviewOnly(wrapper, meta);
    });

    updateVisualPreviewOnly(wrapper, meta);
  }

  function getAllCustomizationInputs(contextEl) { const ctx = getContext(contextEl); return Array.from(ctx.querySelectorAll("input.customization-picker")); }
  function updateAllPreviewsInContext(contextEl) { getAllCustomizationInputs(contextEl).forEach(handleMainInput); }

  function observeVariantPicker(vp) {
    if (!vp || vp.dataset.gmObserved === "1") return; vp.dataset.gmObserved = "1";
    const obs = new MutationObserver(() => { updateAllPreviewsInContext(vp); });
    obs.observe(vp, { attributes: true, attributeFilter: ["data-option1", "data-option2", "data-option3"] });
  }

  document.addEventListener("input", (e) => {
    const target = e.target; if (target instanceof HTMLInputElement && target.classList.contains("customization-picker")) handleMainInput(target);
  });
  
  // This triggers the JSON download the moment they interact with an input field anywhere on the page
  document.addEventListener("focusin", (e) => {
    if (e.target && e.target.classList && e.target.classList.contains("customization-picker")) {
      const wrapper = getWrapperForInput(e.target);
      if (demoIsActive(wrapper)) {
        stopDemo(wrapper);
        handleMainInput(e.target);
      }
      fetchGlossary(getProductMeta(wrapper).scriptFamily);
    }
  });

  document.addEventListener("change", (e) => {
    const target = e.target;
    if (target instanceof HTMLInputElement && target.classList.contains("customization-picker")) { handleMainInput(target); return; }
    if (target instanceof HTMLInputElement && target.type === "radio") { updateAllPreviewsInContext(target); return; }
    if (target instanceof HTMLSelectElement && target.classList.contains("gm-cyrillic-select")) updateAllPreviewsInContext(target);
  });

  document.addEventListener("click", (e) => {
    const target = e.target; if (!(target instanceof HTMLElement)) return;
    const vp = target.closest("#variant-picker"); if (!vp) return;
    setTimeout(() => { updateAllPreviewsInContext(vp); }, 0);
  });

  window.addEventListener("resize", () => { document.querySelectorAll("input.customization-picker").forEach(handleMainInput); });
  window.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("input.customization-picker").forEach((el) => { handleMainInput(el); startDemoIfIdle(el); });
    document.querySelectorAll("#variant-picker").forEach(observeVariantPicker);
  });

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches?.("input.customization-picker")) { handleMainInput(node); startDemoIfIdle(node); }
        node.querySelectorAll?.("input.customization-picker").forEach((el) => { handleMainInput(el); startDemoIfIdle(el); });
        node.querySelectorAll?.("#variant-picker").forEach(observeVariantPicker);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();